/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Confirmdeletedraft2Inputs */



/**

* @param {_Wiki_Confirmdeletedraft2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_confirmdeletedraft2 = /** @type {((inputs?: _Wiki_Confirmdeletedraft2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Confirmdeletedraft2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Entwurf wirklich löschen?")
});
export { _wiki_confirmdeletedraft2 as "_wiki_confirmDeleteDraft" }